<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('inGame.orders')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="changeType">{{type === "line" ? 'Bar' : 'Line'}}</v-btn>
      </v-toolbar>
      <v-card-text>
        <div id="chart"></div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import ApexCharts from "apexcharts";
export default {
  name: "Resume",
  data() {
    return {
      type: "bar",
      chart: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.render()
    },
    render() {
      let categories = this.categories()
      let series = this.series()
      if (this.chart) {
        this.chart.updateOptions({
          series: series,
          xaxis: {
            categories: categories
          },
          chart: {
            type: this.type
          }
        }, true);
      } else {
        this.chart = new ApexCharts(document.querySelector("#chart"), {
          series: series,
          xaxis: {
            categories: categories
          },
          yaxis: {
            min: 0
          },
          chart: {
            type: this.type,
            height: 600
          },
          dataLabels: {
            enabled: false,
          }
        });
        this.chart.render();
      }
    },
    categories() {
      let categories = [];
      for (let index = 0; index < this.week + 1; index++) {
        categories.push(this.$t("general.smallWeek") + (index));
      }
      return categories;
    },
    series() {
      let series = [];
      this.$store.getters["games/companies"].forEach(company => {
        if (company.assemblyMode) {
          for (const supplier of company.data.suppliers) {
            series.push({
              name: company.name + ' -> ' + this.getCompanyName(this.$store.getters["games/companies"], supplier.supplier.toString()),
              data: [company.firstOrder, ...supplier.orders]
            });
          }
        } else {
          if (company.simulatedCompany) {
            series.push({
              name: company.name,
              data: [...company.data.value.orders]
            });
          } else if(company.productionCompany) {
            series.push({
              name: company.name,
              data: [company.firstProduction, ...company.data.value.orders]
            });
          } else {
            series.push({
              name: company.name,
              data: [company.firstOrder * company.suppliers.length, ...company.data.value.orders]
            });
          }
        }
      });
      return series;
    },
    async changeType () {
      await this.chart.destroy()
      this.chart = null
      if (this.type == 'line') {
        this.type = 'bar'
      } else {
        this.type = 'line'
      }
      this.render()
    },
    getCompanyName(companies, id) {
      for (const company of companies) {
        if (company._id.toString() === id) {
          return company.name
        }
      }
    }
  },
  computed: {
    week() {
      let max = 0;
      this.$store.getters["games/assignableCompanies"].forEach(company => {
        if (company.data.value.orders.length > max) {
          max = company.data.value.orders.length;
        }
      });
      return max;
    }
  }
};
</script>
